import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mortgage } from '../../dialer/model/model.mortgage';

@Component({
  selector: 'app-leadlist',
  templateUrl: './leadlist.component.html',
  styleUrls: ['./leadlist.component.css']
})
export class LeadlistComponent implements OnInit {

  @Input() data:Mortgage[];
  @Output() rowclick: EventEmitter<Mortgage> = new EventEmitter();

  public searchtext:string="";
  public recruiting:boolean=false;

  constructor() {   
  }

  ngOnInit() 
  {
    this.searchtext="";   
  }

  onLeadClick(data:any)
  {   
    
    this.searchtext="";
    this.rowclick.emit(data);
    console.log("currcampaign2");
  }

}
